import React from 'react';
import ButtonPrimary, { TButtonProps } from 'components/ButtonPrimary';
import restyle from 'components/../restyler';
import defaultStyles from './buttonConfirm.module.css';

const ButtonConfirm: React.FC<TButtonProps> = ({ styles, ...props }) => (
  <ButtonPrimary {...props} styles={restyle(defaultStyles, styles)} />
);

export default ButtonConfirm;
